// Batch 34 · fork E — Z-1 inventory returns / refused types, Z-3 document read reasons and pages read, Z-4 expert's
// report type, Z-5 "Journal source" GL slot and J14 / J15 manual-only line, Z-6 opening postings not tested. EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
import { fmtCount } from "@/components/Amount";   // STEP 3 combined · B6b: the one count formatter (Western digits)

export const I18N_B34E = {
  en: {
    b34e: {
      inv: {
        ingested: "Inventory ingested: {n} rows",
        refused: "Transaction types not accepted: {list}",
        otherDropped: "{n} row(s) left out (no valid date or a required field blank)",
        returnsNote: "Returns: a sales / customer return adds to stock, a purchase return / return to supplier takes stock out; a bare \"return\" follows its quantity sign (positive in, negative out).",
      },
      extractReason: {
        too_long: "The document is too long for one read (more than 200 pages, or a part of it was refused for its length) — upload the pages that hold the figures as a separate file, then retry.",
        too_large: "The file is too large for one read — retry, or upload the pages with the balances only.",
        busy: "The reading service was busy — retry in a few minutes.",
        timeout: "The read took too long and was stopped — retry.",
        no_key: "Document reading is not set up for this firm — please contact Customer Service.",
        empty: "Nothing could be read from the document (every field came back empty) — check the file is not a blank scan, then retry.",
        unreadable_reply: "The read did not return usable fields — retry.",
        unreadable_pdf: "The PDF could not be opened (damaged or password-protected) — upload an unlocked copy.",
        provider_error: "The reading service returned an error — retry. The detail is with the platform team.",
      },
      pagesRead: "Pages read: {pages} of {total}",
      journalSourceOpt: "Journal source (opt.)",
      j14Manual: "Journal source imported: system and sub-ledger sources not tested — {n} lines",
      j14AllSources: "Test every journal source",
      openingNotTested: "{n} opening-balance line(s) not tested",
    },
    docs: { types: { expert_report: "Expert's report / valuation" } },
    docFields: {
      report_date: "Report date", expert_name: "Expert / valuer", valuation_date: "Valuation date",
      valuation_amount: "Value / obligation", method: "Method", key_assumptions: "Key assumptions",
      pages_read: "Pages read",
    },
  },
  ar: {
    b34e: {
      inv: {
        ingested: "تم إدخال المخزون: {n} صف",
        refused: "أنواع حركة غير مقبولة: {list}",
        otherDropped: "استُبعد {n} صف (لا يوجد تاريخ صالح أو حقل مطلوب فارغ)",
        returnsNote: "المرتجعات: مرتجع المبيعات / مرتجع العميل يُضاف إلى المخزون، ومرتجع المشتريات / المرتجع إلى المورد يُخرج من المخزون؛ و\"مرتجع\" دون تحديد يتبع إشارة الكمية (موجبة دخول، سالبة خروج).",
      },
      extractReason: {
        too_long: "المستند أطول من أن يُقرأ مرة واحدة (أكثر من 200 صفحة، أو رُفض جزء منه بسبب طوله) — ارفع الصفحات التي تحتوي الأرقام كملف منفصل ثم أعد المحاولة.",
        too_large: "الملف أكبر من أن يُقرأ مرة واحدة — أعد المحاولة، أو ارفع الصفحات التي تحتوي الأرصدة فقط.",
        busy: "خدمة القراءة مشغولة — أعد المحاولة بعد دقائق.",
        timeout: "استغرقت القراءة وقتاً طويلاً وأُوقفت — أعد المحاولة.",
        no_key: "قراءة المستندات غير مُعدّة لهذا المكتب — يرجى التواصل مع خدمة العملاء.",
        empty: "لم يُقرأ شيء من المستند (جميع الحقول فارغة) — تأكد أن الملف ليس مسحاً فارغاً ثم أعد المحاولة.",
        unreadable_reply: "لم تُرجع القراءة حقولاً قابلة للاستخدام — أعد المحاولة.",
        unreadable_pdf: "تعذّر فتح ملف PDF (تالف أو محمي بكلمة مرور) — ارفع نسخة غير مقفلة.",
        provider_error: "أرجعت خدمة القراءة خطأ — أعد المحاولة. التفاصيل لدى فريق المنصة.",
      },
      pagesRead: "الصفحات المقروءة: {pages} من {total}",
      journalSourceOpt: "مصدر القيد (اختياري)",
      j14Manual: "تم استيراد مصدر القيد: مصادر النظام والسجلات الفرعية لم تُختبر — {n} سطر",
      j14AllSources: "اختبار جميع مصادر القيود",
      openingNotTested: "{n} سطر من الأرصدة الافتتاحية لم يُختبر",
    },
    docs: { types: { expert_report: "تقرير خبير / تقييم" } },
    docFields: {
      report_date: "تاريخ التقرير", expert_name: "الخبير / المقيّم", valuation_date: "تاريخ التقييم",
      valuation_amount: "القيمة / الالتزام", method: "الطريقة", key_assumptions: "الافتراضات الرئيسية",
      pages_read: "الصفحات المقروءة",
    },
  },
};

// Z-1: "Inventory ingested: 45,380 rows · Transaction types not accepted: Transfer (2), Scrap sale (1)"
export function inventoryIngestedText(res, t) {
  const r = res || {};
  const parts = [String(t("b34e.inv.ingested") || "").replace("{n}", fmtCount(r.rows_ingested || 0))];
  const refused = Object.entries(r.dropped_type_counts || {}).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
  if (refused.length) {
    parts.push(String(t("b34e.inv.refused") || "").replace("{list}",
      refused.map(([k, v]) => `${k} (${fmtCount(v)})`).join(", ")));
  }
  const other = Number(r.dropped_bad_date || 0) + Number(r.dropped_missing_req || 0);
  if (other > 0) parts.push(String(t("b34e.inv.otherDropped") || "").replace("{n}", fmtCount(other)));
  return parts.join(" · ");
}

// Z-3: the reason a read failed, in the user's language (falls back to the fixed text)
export function extractionReasonText(doc, t) {
  const code = doc?.extraction_reason;
  const key = code ? `b34e.extractReason.${code}` : "";
  const txt = key ? t(key) : "";
  return txt && txt !== key ? txt : "";
}

// Z-3: "Pages read: 1, 2, 3, 65, 66, 67 of 67"
export function pagesReadText(fields, t) {
  const p = fields?.pages_read;
  if (!p || !Array.isArray(p.pages)) return "";
  // PR 53 · F6: a long document read in parts — "Pages read: 1–20, 21–40 of 40 (2 parts)"
  if (Array.isArray(p.chunks) && p.chunks.length) {
    const ranges = p.chunks.map((c) => (c[0] === c[1] ? `${c[0]}` : `${c[0]}–${c[1]}`)).join(", ");
    return String(t("p53r.pagesReadParts") || "").replace("{ranges}", ranges).replace("{total}", String(p.total))
      .replace("{n}", String(p.chunks.length));
  }
  return String(t("b34e.pagesRead") || "").replace("{pages}", p.pages.join(", ")).replace("{total}", String(p.total));
}

// Z-5 / Z-6: the J14 / J15 manual-only line and the opening-not-tested line of a rule card
export function b34eCardLines(code, data, t) {
  const out = [];
  if ((code === "J14" || code === "J15") && data?.j14_source_column_available && !data?.j14_all_sources) {
    out.push({ key: "manual", text: String(t("b34e.j14Manual") || "").replace("{n}", fmtCount(data?.j14_non_manual_not_tested || 0)) });
  }
  const ob = Number((data?.opening_not_tested || {})[code] || 0);
  if (ob > 0 && !["J3", "J14", "J15"].includes(code)) {
    out.push({ key: "opening", text: String(t("b34e.openingNotTested") || "").replace("{n}", fmtCount(ob)) });
  }
  return out;
}

export default I18N_B34E;
